import {API_END_POINT} from "../../../../constants/constants";

export const LOGIN = '[Login]'
export const LOGOUT = '[Logout]'

export const POST_LOGIN = `${LOGIN} Post`
export const POST_LOGOUT = `${LOGOUT} Post`
export const POST_LOGIN_FAILED = `${LOGIN} Failed`
export const POST_LOGIN_SUCCESS = `${LOGIN} Success`

export const postLogin = ({username, password}) => ({
    type: POST_LOGIN,
    payload: {
        data: API_END_POINT,
        body: {username, password}
    }
})

export const postLogout = ({query}) => ({
    type: POST_LOGOUT,
    payload: {
        data: query
    }
})

export const postLoginSuccess = () => ({
    type: POST_LOGIN_SUCCESS,
    meta: {
        analytics: {
            event: 'click',
            actionGoogle: 'loginSucces',
            libelle: 'Connexion réussie',
        },
        entity: LOGIN
    }
})

export const postLoginFailed = () => ({
    type: POST_LOGIN_FAILED,
    meta: {
        analytics: {
            event: 'click',
            actionGoogle: 'loginEchec',
            libelle: 'Connexion échouée',
        },
        entity: LOGIN
    }
})
